import { Button, styled } from "@mui/material";
import {
  BOX_SHADOW_SIZE_MEDIUM,
  PRIMARY_COLOR,
} from "../layout/LayoutConstants";

interface PillButtonProps {
  isSelected?: boolean;
  iconOnly?: boolean;
  compactOnMobile?: boolean;
  compact?: boolean;
  primary?: boolean;
  component?: React.ElementType;
}

const COMPACT_STYLING = {
  border: "none",
  paddingTop: 1,
  paddingBottom: 1,
  paddingLeft: 2,
  paddingRight: 2,
  boxShadow: "none !important",
  fontSize: "80%",
  height: "initial",
  gap: 0,
};

const PillButton = styled(Button, {
  shouldForwardProp: (prop) => {
    return (
      prop !== "isSelected" &&
      prop !== "iconOnly" &&
      prop !== "compactOnMobile" &&
      prop !== "compact" &&
      prop !== "primary"
    );
  },
})<PillButtonProps>(
  ({ theme, isSelected, iconOnly, compactOnMobile, compact, primary }) =>
    theme.unstable_sx({
      whiteSpace: "nowrap",
      paddingLeft: 3,
      paddingRight: 3,
      height: "40px",
      border: "2px solid ",
      borderColor: isSelected ? "black" : "transparent",
      borderRadius: "100px",
      background: "white",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      flexShrink: 0,
      gap: 0.5,
      "&, > *": {
        color: "#222",
        fontSize: "14px",
      },
      "&.Mui-disabled": {
        "&, > *": {
          color: "#d6d6d6",
          opacity: 0.5,
        },
      },
      "&:hover": {
        boxShadow: BOX_SHADOW_SIZE_MEDIUM,
      },
      ".MuiButton-startIcon": {
        fontSize: "20px",
        ".MuiSvgIcon-root": {
          fontSize: "inherit",
        },
      },
      ...(primary
        ? {
            backgroundColor: PRIMARY_COLOR,
            borderColor: "transparent",
            "&, .MuiSvgIcon-root": {
              color: "white !important",
            },
          }
        : {}),
      fontWeight: isSelected ? "bold" : "normal",
      ...(iconOnly
        ? {
            padding: 0.5,
            border: 0,
            minWidth: "initial",
            height: "initial",
            backgroundColor: "transparent",
            ".MuiButton-icon": {
              margin: 0,
              fontSize: "25px",
              ".MuiSvgIcon-root": {
                fontSize: "inherit",
              },
            },
            "&:hover": {
              boxShadow: "none",
            },
          }
        : {}),
      ...(compactOnMobile
        ? {
            [theme.breakpoints.only("xs")]: COMPACT_STYLING,
          }
        : {}),
      ...(compact ? COMPACT_STYLING : {}),
      // AJB: move to specific buttons or take a prop?
      // [hideTextOnMobile ? theme.breakpoints.only('xs') : ""]: {
      //   padding: 1,
      //   minWidth: 'auto',
      //   '.MuiTypography-root': {
      //     display: "none",
      //   },
      //   '.MuiButton-icon': {
      //     '&, .MuiSvgIcon-root': {
      //       margin: 0,
      //     },
      //     display: 'flex',
      //     justifyContent: 'center',
      //   },
      // },
      '&.MuiButton-loading': {
        color: PRIMARY_COLOR + " !important",
        '.MuiButton-loadingIndicator': {
          color: 'white',
        },
        '.MuiButton-icon': {
          display: 'none',
        }
      },
    }),
);

export default PillButton;
